import Header from "../componentes/Header";

function MyAccount() {
    return(
        <Header/>
    )
}

export default MyAccount;